import React from 'react';
import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { NotificationProvider } from './context/NotificationContext';
import { WalletProvider } from './context/WalletContext';
import { useNetworkGuard } from './hooks/useNetworkGuard';

import Header from './components/layout/Header';
import BottomNav from './components/layout/BottomNav';
import Footer from './components/layout/Footer';
import AnnouncementBar from './components/layout/AnnouncementBar';
import WrongNetworkBanner from './components/wallet/WrongNetworkBanner';
import GrapheneLattice from './components/background/GrapheneLattice';

import Dashboard from './pages/Dashboard';
import Invest from './pages/Invest';
import Team from './pages/Team';
import Contributor from './pages/Contributor';
import Ranks from './pages/Ranks';
import Register from './pages/Register';
import Admin from './pages/Admin';
import Swap from './pages/Swap';

import './styles/theme.css';
import './styles/globals.css';
import './styles/animations.css';
import './styles/layout.css';
import './styles/components.css';
import './styles/pages.css';

const Shell = () => {
  useNetworkGuard();
  return (
    <>
      <GrapheneLattice />
      <AnnouncementBar />
      <WrongNetworkBanner />
      <div className="app-shell">
        <Header />
        <main className="app-main">
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/register" element={<Register />} />
            <Route path="/invest" element={<Invest />} />
            <Route path="/team" element={<Team />} />
            <Route path="/ranks" element={<Ranks />} />
            <Route path="/swap" element={<Swap />} />
            <Route path="/contributor" element={<Contributor />} />
            <Route path="/admin" element={<Admin />} />
            {/* Legacy redirects */}
            <Route path="/investments" element={<Navigate to="/invest" replace />} />
            <Route path="/rewards" element={<Navigate to="/" replace />} />
            <Route path="/referrals" element={<Navigate to="/team" replace />} />
            <Route path="*" element={<Dashboard />} />
          </Routes>
          <Footer />
        </main>
      </div>
      <BottomNav />
    </>
  );
};

const App = () => (
  <NotificationProvider>
    <WalletProvider>
      <HashRouter>
        <Shell />
      </HashRouter>
    </WalletProvider>
  </NotificationProvider>
);

export default App;
